export enum ButtonEventString {
  CancelEntireOrder = 'cancelEntireOrder',
  SaveFavOrder = 'saveFavOrder',
  ScheduleTime = 'scheduleTime',
  Removereward = 'removereward',
  RemoveItem = 'removeItem',
  RemoveLimitedTimeItem = 'removeLimitedTimeItem',
  AddToFavorite = 'addToFavorite',
  DontAskagain = 'dontAskagain',
  NotNow = 'notNow',
  GotIt = 'gotIt',
  RemoveOrderedItem = 'removeOrderedItem',
  Changelocation = 'changelocation',
  Removeloading = 'removeloading',
  Choosenewitem = 'choosenewitem',
  Editdrinks = 'editdrinks',
  RemoveModifierGroups = 'removeModifierGroups',
  RemoveModifiers = "removeModifiers",
  RemoveSpecialInstructions = "removeSpecialInstructions",
  EditUnavailableModifierRecipe ="editUnavailableModifierRecipe",
  EditModifierGroupWithServeRestrictions = 'editModifierGroupWithServeRestrictions',
  RemoveRecipe = 'removeRecipe'
}

export enum MenuItemType {
  Modifier,
  ModifierGroup,
  Recipe,
  CustomizationGroup,
  SpecialInstruction
}
